import { withStyles } from '@material-ui/core';
import clsx from 'clsx';
import history from 'history.js';
import React from 'react';
import _ from '@lodash';

const styles = theme => ({
    root: {
        '& .logo-icon': {
            //width     : 24,
            //height    : 24,
            transition: theme.transitions.create(['width', 'height'], {
                duration: theme.transitions.duration.shortest,
                easing: theme.transitions.easing.easeInOut
            })
        }
    },
    bgTheme: {
        backgroundColor: theme.palette.primary.main
    }
});

function Logo({ classes, theme }) {
    return (
        <div className={clsx(classes.root, "flex items-center cursor-pointer")}>
            <img
                className={clsx(classes.bgTheme, "logoPrincipal h-40")}
                src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                alt="Logo Principal"
                onClick={() => home()}
            />
        </div>
    );
}

function home() {
    history.push("/home");
}

export default withStyles(styles, { withTheme: true })(Logo);
